/**
* @fileoverview This file is generated by the Angular template compiler.
* Do not edit.
* @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
* tslint:disable
*/
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var styles = ["input[_ngcontent-%COMP%] {\n  -moz-appearance: none;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.6) inset;\n  font-family: \"Vodafone\", Arial, sans-serif;\n  font-size: 14px;\n  color: #333;\n  padding: 14px 10px;\n  width: 100%;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box; }"];
export { styles as styles };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/shared/components/text-input/text-input.component.scss.shim.ngstyle.js
// module id = null
// module chunks = 